module.exports = __webpack_public_path__ + "img/ai.33ccfdc1.png";